<template>
  <div class="ml-1.5 @sm/player:ml-3 flex items-center text-xs @sm/player:text-sm @md/player:text-base @2xl/player:text-lg @2xl/player:text-xl font-medium">
    <div> {{ formatSeconds(Math.floor(playerStore.fulltime)) }} </div>
    <div class="mx-1 text-white/80">/</div>
    <div> {{ formatSeconds(Math.floor(videoStore.video.duration)) }}</div>
  </div>
</template>

<script setup>  
import { PlayerStore } from '@/front/stores/player_store.js';
const playerStore = PlayerStore();
import { VideoStore } from '@/front/stores/video_store.js';
const videoStore = VideoStore();
import { formatSeconds } from '@/front/composables/TimeFormatter';
import { useGlobalRenderTracker } from '@/front/composables/GlobalRenderTracker.js'
if (playerStore.isDebugPerformance) {
  useGlobalRenderTracker('CustomTime', { logLevel: 'none' })
}
</script>

<style scoped>
.time {
  contain: content;
  font-family: 'Geist', sans-serif;
}
</style>
